export default (settings: any) => settings['externalDatabase'] * 4
